import React from "react";
import EmailLoggerCard from "./EmailLoggerCard";

const EmailLoggerCards = ({ items }) => {
  return (
    <div className="interest-form-grid">
      {items.map((item) => {
        return <EmailLoggerCard info={item} />;
      })}
    </div>
  );
};

export default EmailLoggerCards;
